import React from 'react';
import moment from 'moment';
import {
  Col,
  Form,
  Row
} from 'react-bootstrap';

export default function Info({schedule}) {

  return (
    <Row>
      <Col md="6">
        <Form.Group>
          <p>Audit: Internal Audit of {schedule.auditee.department.DEPT_NAME}</p>
        </Form.Group>
      </Col>
      <Col md="6">
        <Form.Group>
          <p>Periode: {moment(schedule.START_DATE).format ('DD MMM YYYY')} to {moment(schedule.END_DATE).format('DD MMMM YYYY')}</p>
        </Form.Group>
      </Col>
      <Col md="6">
        <Form.Group>
          <p>Instrument: {schedule.instrument.standard.STANDARD_NAME} {schedule.instrument.INSTRUMENT_NAME}</p>
        </Form.Group>
      </Col>
      <Col md="6">
        <Form.Group>
          <p>Auditor(s): {schedule.auditorTeams.map(member => member.auditor.employee.EMP_NAME).join(`, `)}</p>
        </Form.Group>
      </Col>
    </Row>
  );
}